import React, { FC, useCallback } from 'react';
import { MessageModalViewType } from '../../types/view/MessageModalViewType';
import { CommonModal } from '../CommonModal';
import { BottomButton } from '../ModalItem/BottomButton';
import commonModalClass from '../../assets/scss/CommonModal.module.scss';

export const MessageModal: FC<{
  active: boolean;
  closeFunc: () => void;
  messageModal: MessageModalViewType | null;
}> = ({ active, closeFunc, messageModal }) => {
  const clickBtnHandler = useCallback(() => {
    closeFunc();

    if (messageModal?.clickBtnFunc) messageModal.clickBtnFunc();
  }, [closeFunc, messageModal]);

  if (!messageModal) return <></>;

  const content = (
    <>
      {messageModal.title ? (
        <div
          className={commonModalClass.messageTitle}
          style={{ lineHeight: '26px' }}
        >
          {(messageModal.title || '').split('\n').map((line, index) => (
            <React.Fragment key={index}>
              {line}
              {index < (messageModal.title || '').split('\n').length - 1 && <br />}
            </React.Fragment>
          ))}
        </div>
      ) : null}
      <div
        className={commonModalClass.messageDetail}
        style={{ marginBottom: messageModal.title ? '40px' : '30px' }}
      >
        {messageModal.message.split(/\n/).map((text, index) => {
          if (text.includes('お問い合わせフォーム')) {
            return <p key={index}>{replaceContactFormLink(text)}</p>;
          } else {
            return <p key={index}>{text}</p>;
          }
        })}
      </div>
      <div
        className={commonModalClass.btnContainer}
        style={{ marginBottom: messageModal.title ? '20px' : '0px' }}
      >
        <BottomButton
          buttonTitle="閉じる"
          clickFunc={clickBtnHandler}
        />
      </div>
    </>
  );

  return (
    <CommonModal
      active={active}
      closeFunc={clickBtnHandler}
    >
      {content}
    </CommonModal>
  );
};

// お問い合わせフォームリンク置換
const replaceContactFormLink = (text: string) => {
  const replacedText = text.split('お問い合わせフォーム').map((part, index) => {
    if (index === text.split('お問い合わせフォーム').length - 1) {
      return part;
    }
    return (
      <>
        {part}
        <a
          href="https://support.zenb.jp/hc/ja/requests/new"
          target="_blank"
          rel="noopener noreferrer"
          style={{ color: '#004727', textDecoration: 'underline' }}
        >
          お問い合わせフォーム
        </a>
      </>
    );
  });

  return replacedText;
};
